import React from 'react'
import cx from 'classnames'
import './BatteryItem.css'

function getBatteryColor(battery, lowPower, normalPower) {
  const indexState = battery.indexState
  const chargeState = battery.chargeState //充电状态(-1:未知 0:空闲 1:充电中)
  const shareLock = Number(battery.shareLock)
  const power = Number(battery.power)
  const current = Number(battery.current)
  const lowGrade = Number(battery.lowGrade)

  //全球統一顏色 jira https://jr.charge-spot.com/browse/GL-6932
  //对应色值 Confluence https://cf.charge-spot.com/pages/viewpage.action?pageId=66427799
  const grade = Number(battery.grade)
  const capacity = Number(battery.capacity)

  if (indexState === 0) {
    //无电池
    return 'white'
  } else if (indexState === 1) {
    //孔位状态为1的电池，有多种状态
    //低分电池
    if (lowGrade === 1) {
      return 'brown'
    }
    //黑名单电池
    const shareLockBlack = shareLock === 1
    const gradeBlack =
      battery.powerNo !== '' && // real battery
      grade >= 0 &&
      grade <= 30
    const capacityBlack = capacity > 0 && capacity < 1000
    if (shareLockBlack || gradeBlack || capacityBlack) {
      return 'black'
    }
    if (power < normalPower && current === 0) {
      if (chargeState === 1) {
        //充电电量异常  橙色
        return 'orange'
      } else {
        //低电量电池
        return 'lightBlue'
      }
    }
    if (power < normalPower) {
      //低电量电池
      return 'lightBlue'
    }
    if (power >= normalPower) {
      //正常电池  蓝色
      return 'blue'
    }
  } else if (indexState === 2) {
    //充电异常
    //低分电池
    if (lowGrade === 1) {
      return 'brown'
    }
    //黑名单电池
    const shareLockBlack = shareLock === 1
    const gradeBlack =
      battery.powerNo !== '' && // real battery
      grade >= 0 &&
      grade <= 30
    const capacityBlack = capacity > 0 && capacity < 1000
    if (shareLockBlack || gradeBlack || capacityBlack) {
      return 'black'
    }

    return 'yellow'
  } else if (indexState === 3 || indexState === 10) {
    //通讯异常
    //低分电池
    if (lowGrade === 1) {
      return 'brown'
    }
    //黑名单电池
    const shareLockBlack = shareLock === 1
    const gradeBlack =
      battery.powerNo !== '' && // real battery
      grade >= 0 &&
      grade <= 30
    const capacityBlack = capacity > 0 && capacity < 1000
    if (shareLockBlack || gradeBlack || capacityBlack) {
      return 'black'
    }

    return 'darkGrey'
  } else if (indexState === 4 || indexState === 8) {
    //无法弹出
    //低分电池
    if (lowGrade === 1) {
      return 'brown'
    }
    //黑名单电池
    const shareLockBlack = shareLock === 1
    const gradeBlack =
      battery.powerNo !== '' && // real battery
      grade >= 0 &&
      grade <= 30
    const capacityBlack = capacity > 0 && capacity < 1000
    if (shareLockBlack || gradeBlack || capacityBlack) {
      return 'black'
    }

    return 'red'
  } else if (indexState === -1) {
    //机芯故障
    //低分电池
    if (lowGrade === 1) {
      return 'brown'
    }
    //黑名单电池
    const shareLockBlack = shareLock === 1
    const gradeBlack =
      battery.powerNo !== '' && // real battery
      grade >= 0 &&
      grade <= 30
    const capacityBlack = capacity > 0 && capacity < 1000
    if (shareLockBlack || gradeBlack || capacityBlack) {
      return 'black'
    }
    return 'grey'
  } else if (indexState === 11) {
    //异常投放
    //低分电池
    if (lowGrade === 1) {
      return 'brown'
    }
    //黑名单电池
    const shareLockBlack = shareLock === 1
    const gradeBlack =
      battery.powerNo !== '' && // real battery
      grade >= 0 &&
      grade <= 30
    const capacityBlack = capacity > 0 && capacity < 1000
    if (shareLockBlack || gradeBlack || capacityBlack) {
      return 'black'
    }
    return 'purple'
  }
}

function BatteryItem(props) {
  const { className, battery, onClick, lowPower, normalPower } = props
  const { index, powerId, power, capacity } = battery
  // TODO: all show color
  return (
    <li
      className={cx(
        'BatteryItem',
        `BatteryItem--${getBatteryColor(battery, lowPower, normalPower)}`,
        battery.indexSlotState === 2 && 'hidden',
        className
      )}
      onClick={() => {
        if (battery.indexSlotState === 2) return
        onClick()
      }}
    >
      <p>{index}</p>
      {powerId !== '' && <p>{power}%</p>}
      {capacity > 0 && capacity < 1000 && <p>LC</p>}
    </li>
  )
}

export default BatteryItem
